import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function LanguageSplash() {
  const {
    selectLanguage,
    coverImage
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="fixed inset-0 z-[100] flex items-center justify-center bg-void overflow-hidden" data-id="element-188">
      {/* Background effects */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-189">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-flame/10 rounded-full blur-[150px] animate-pulse" data-id="element-190" />
        <div className="absolute top-1/3 left-1/4 w-[400px] h-[400px] bg-purple-electric/10 rounded-full blur-[120px] animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-191" />
        <div className="absolute bottom-1/3 right-1/4 w-[350px] h-[350px] bg-magenta/8 rounded-full blur-[100px] animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-192" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center px-6 text-center" data-id="element-193">
        {/* Book cover preview */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mb-10" data-id="element-194">
          <div className="absolute -inset-8 bg-gradient-to-br from-flame/30 via-magenta/20 to-purple-electric/25 rounded-3xl blur-2xl animate-pulse" data-id="element-195" />
          <div className="relative w-48 sm:w-56 rounded-xl overflow-hidden shadow-glow-psyche" data-id="element-196">
            <img src="https://cdn.magicpatterns.com/uploads/4xHZLM843x38HVZ59Epr6Z/Screenshot_2026-03-05_at_8.38.40_PM.png" alt="DMT Book Cover" className="w-full h-auto object-cover rounded-xl" data-id="element-197" />
          </div>
        </motion.div>

        {/* Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-10" data-id="element-198">
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white mb-2" data-id="element-199">
            Choose your language
          </h1>
          <p className="font-sans text-white/40 text-lg" data-id="element-200">Elige tu idioma</p>
        </motion.div>

        {/* Language buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-4 w-full max-w-md" data-id="element-201">
          {/* Spanish button */}
          <motion.button onClick={() => selectLanguage('es')} className="group relative flex-1 px-8 py-5 rounded-xl bg-white/[0.03] backdrop-blur-xl border border-gold/30 overflow-hidden transition-all duration-500 hover:border-gold/60" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-202">
            <div className="absolute inset-0 bg-gradient-to-br from-gold/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-203" />
            <div className="relative flex items-center justify-center gap-3" data-id="element-204">
              <span className="text-2xl" data-id="element-205">🇪🇸</span>
              <span className="font-serif text-xl font-bold text-white" data-id="element-206">
                Español
              </span>
            </div>
          </motion.button>

          {/* English button */}
          <motion.button onClick={() => selectLanguage('en')} className="group relative flex-1 px-8 py-5 rounded-xl bg-white/[0.03] backdrop-blur-xl border border-purple-electric/30 overflow-hidden transition-all duration-500 hover:border-purple-electric/60" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-207">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-electric/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-208" />
            <div className="relative flex items-center justify-center gap-3" data-id="element-209">
              <span className="text-2xl" data-id="element-210">🇺🇸</span>
              <span className="font-serif text-xl font-bold text-white" data-id="element-211">
                English
              </span>
            </div>
          </motion.button>
        </motion.div>

        {/* Subtle hint */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 1
      }} className="font-sans text-white/20 text-xs mt-8 tracking-wide" data-id="element-212">
          DMT · La Molécula de Dios / The Spirit Molecule
        </motion.p>
      </div>
    </motion.div>;
}